<template>
  <div
    class="switcher"
    :class="{ 'switcher--disabled': disabled }"
    @click="disabled ? null : nextValue()"
    @wheel="disabled ? null : handleWheel($event)"
  >
    {{ list[value] }}
  </div>
</template>

<script>
export default {
  props: ["value", "list", "disabled"],
  methods: {
    prevValue() {
      let newValue = this.list.length - 1;

      if (this.value > 0) {
        newValue = this.value - 1;
      }

      this.$emit("input", newValue);
    },
    nextValue() {
      let newValue = 0;

      if (this.value < this.list.length - 1) {
        newValue = this.value + 1;
      }

      this.$emit("input", newValue);
    },
    handleWheel(e) {
      const delta = Math.sign(e.deltaY);
      if (delta < 0) this.prevValue();
      else this.nextValue();
    },
  },
};
</script>

<style scoped>
.switcher {
  background: #f4f4f4;
  border: 1px solid #cecece;
  border-radius: 4px;
  cursor: ns-resize;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  padding: 9px 12px;
  transition: 0.3s ease;
  user-select: none;
}
.switcher--disabled {
  opacity: 0.25;
}
</style>
